import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import { baseQuery } from "../services/baseQuery";
// import { createLogger } from "redux-logger";
// import { thunk } from "redux-thunk";
// import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";

// const persistConfig = {
//   key: "wholesale-admin/sjnfkd",
//   storage,
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// const logger = createLogger();

// look for serializable check in later stage
const store = configureStore({
  reducer: rootReducer,
  // reducer: persistedReducer,
  // middleware: getDefaultMiddleware =>getDefaultMiddleware({ serializableCheck: false }).concat(thunk, logger),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      baseQuery.middleware,
    ),
});

// export const persistor = persistStore(store);

export default store;
